<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <table class="table table-hover table-bordered table-condensed table-align-center custom-table">
    <thead>
      <tr>
        <th>GROUP NAME</th>
        <th style="text-align: center; background-color: transparent !important; border: none;">
          <i class="fa fa-plus-circle color-green" (click)="addGroup()" style="cursor: pointer;"></i>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (group of allSelectedGroups; track $index; let i = $index) {
<tr>
        <td>
          <input type="text" [(ngModel)]="group.GROUP_NAME" class="form-control input-sm subtableRowHeight">
        </td>
        <td style="border:none;"></td>
      </tr>
}
      @for (group of newGroups; track $index; let j = $index) {
<tr>
        <td>
          <input type="text" [(ngModel)]="group.GROUP_NAME" class="form-control input-sm subtableRowHeight">
        </td>
        <td style="text-align: center; border: none;">
          <i class="fa fa-minus-circle color-red" (click)="removeGroup(j)" style="cursor: pointer;"></i>
        </td>
      </tr>
}
    </tbody>
  </table>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
